/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_IngestInputs */

const es_tools_drive_ingest = /** @type {(inputs: Tools_Drive_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestando desde Google Drive...`)
};

const en_tools_drive_ingest = /** @type {(inputs: Tools_Drive_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesting from Google Drive...`)
};

/**
* | output |
* | --- |
* | "Ingesting from Google Drive..." |
*
* @param {Tools_Drive_IngestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_ingest = /** @type {((inputs?: Tools_Drive_IngestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_IngestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_ingest(inputs)
	return en_tools_drive_ingest(inputs)
});
export { tools_drive_ingest as "tools.drive.ingest" }